import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.css']
})
export class AppComponent {

	show: boolean = false;
	fullScreen: boolean = false;
	template: any;
	currentRoute: string = '';

	constructor(
		public location: Location, 
		private router: Router, 
		public translate: TranslateService) {
		translate.addLangs(['en', 'es']);
		const cl: any = localStorage.getItem('currentLang') ? localStorage.getItem('currentLang') : 'en';
		translate.setDefaultLang(cl);
		localStorage.setItem('currentLang', cl);
		translate.use(cl);
		this.router.events.subscribe((event: any) => {
			if (event instanceof NavigationEnd) {
				this.currentRoute = event.url.toString();
				if (this.currentRoute == '/') {
					sessionStorage.clear();
					this.router.navigateByUrl('/login');
				}
			}
		})
	}

	loaderStart() {
		this.show = true;
		this.fullScreen = true;
		this.template = ``
	}

	loaderStop() {
		this.show = false
	}

}
